export const downloadsData = [
  {
    id: 1,
    productName: "COLTEC Evoke",
    category: "Interactive Flat Panel",
    catalogue: "Catalogue",
    catalogueUrl: "https://content.qeeb.in/coltec/download/evoke-catalogue.pdf",
    datasheet: "Datasheet",
    datasheetUrl: "https://content.qeeb.in/coltec/download/evoke-datasheet.pdf",
    firmware: "Firmware",
    firmwareUrl: "https://content.qeeb.in/coltec/download/evoke-firmware.zip",
    imageUrl:
      "https://content.qeeb.in/coltec/download/evoke-flat-panel-download.webp",
  },
  {
    id:2,
    productName: "COLTEC Rise",
    category: "Interactive Flat Panel",
    catalogue: "Catalogue",
    catalogueUrl: "https://content.qeeb.in/coltec/download/rise-catalogue.pdf",
    datasheet: "Datasheet",
    datasheetUrl: "https://content.qeeb.in/coltec/download/rise-datasheet.pdf",
    firmware: "Firmware",
    firmwareUrl: "https://content.qeeb.in/coltec/download/rise-firmware.zip",
    imageUrl:
      "https://content.qeeb.in/coltec/download/rise-flat-panel-download.webp",
  },
  {
    id:3,
    productName: "COLTEC Inspire",
    category: "Interactive Flat Panel",
    catalogue: "Catalogue",
    catalogueUrl:
      "https://content.qeeb.in/coltec/download/inspire-catalogue.pdf",
    datasheet: "Datasheet",
    datasheetUrl:
      "https://content.qeeb.in/coltec/download/inspire-datasheet.pdf",
    firmware: "Firmware",
    firmwareUrl: "https://content.qeeb.in/coltec/download/inspire-frimware.zip",
    imageUrl:
      "https://content.qeeb.in/coltec/download/insipire-flat-panel-download.webp",
  },
  {
    id:4,
    productName: "COLTEC Vista",
    category: "Commercial Display",
    catalogue: "Catalogue",
    catalogueUrl: "https://content.qeeb.in/coltec/download/vista-catalogue.pdf",
    datasheet: "Datasheet",
    datasheetUrl: "https://content.qeeb.in/coltec/download/vista-datasheet.pdf",
    firmware: "Firmware",
    firmwareUrl: "https://content.qeeb.in/coltec/download/vista-frimware.zip",
    imageUrl:
      "https://content.qeeb.in/coltec/download/vista-display-download.webp",
  },
  {
    id:5,
    productName: "COLTEC Inertia",
    category: "Active LED Video Wall",
    catalogue: "Catalogue",
    catalogueUrl:
      "https://content.qeeb.in/coltec/download/inertia-catalogue.pdf",
    datasheet: "Datasheet",
    datasheetUrl:
      "https://content.qeeb.in/coltec/download/inertia-datasheet.pdf",
    firmware: "Firmware",
    firmwareUrl: "https://content.qeeb.in/coltec/download/inertia-frimware.zip",
    imageUrl: "https://content.qeeb.in/coltec/download/inertia-active-led.webp",
  },
];
